export function getVideoPlaybackUrl(
    vimeoId?: string | null,
    videoFileUrl?: string | null
): string {
    return vimeoId?.trim() || videoFileUrl?.trim() || ""
}
